import React, { useEffect, useState } from 'react'
import {
  Paper,
  Typography,
  CircularProgress,
  Button
} from '@material-ui/core'
import axios from 'axios'
import { useLocation, useNavigate } from 'react-router-dom'

function ValidateEmail() {

  const location = useLocation()
  const navigate = useNavigate()

  const [loading, setLoading] = useState(true)
  const [success, setSuccess] = useState(false)
  const [message, setMessage] = useState('')

  const token = new URLSearchParams(location.search)
    .get('token')

  useEffect(() => {

    const validateEmail = async () => {

      try {

        await axios.get(
          `${process.env.REACT_APP_BACKEND}/api/validar-email`,
          {
            params: {
              token
            }
          }
        )

        setSuccess(true)

        setMessage(
          'E-mail validado com sucesso! Você já pode realizar o login.'
        )

        setTimeout(() => {
          navigate('/login')
        }, 10000)

      } catch (error: any) {

        setSuccess(false)

        setMessage(
          error?.response?.data?.message ||
          'Link inválido ou expirado.'
        )

      } finally {
        setLoading(false)
      }
    }

    validateEmail()

  }, [])

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#f4f4f4'
      }}
    >
      <Paper
        elevation={3}
        style={{
          width: 500,
          padding: 40,
          textAlign: 'center'
        }}
      >

        {loading ? (
          <>
            <CircularProgress />

            <Typography
              style={{
                marginTop: 20
              }}
            >
              Validando e-mail...
            </Typography>
          </>
        ) : (
          <>
            <Typography
              variant="h5"
              style={{
                color: success
                  ? '#2e7d32'
                  : '#d32f2f',
                fontWeight: 700,
                marginBottom: 20
              }}
            >
              {success
                ? 'E-mail Validado'
                : 'Erro ao Validar'}
            </Typography>

            <Typography
              style={{
                marginBottom: 30
              }}
            >
              {message}
            </Typography>

            {success && (
              <Typography
                style={{
                  fontSize: 14,
                  marginBottom: 20
                }}
              >
                Você será redirecionado em 10 segundos.
              </Typography>
            )}

            <Button
              variant="contained"
              onClick={() => navigate('/login')}
              style={{
                backgroundColor: '#1A3661',
                color: '#fff'
              }}
            >
              Ir para Login
            </Button>
          </>
        )}
      </Paper>
    </div>
  )
}

export default ValidateEmail